import { render, staticRenderFns } from "./WfaOrWfhView.vue?vue&type=template&id=4d453455"
import script from "./WfaOrWfhView.vue?vue&type=script&lang=js"
export * from "./WfaOrWfhView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports